import React, {Component} from 'react';
import { HotTable } from '@handsontable/react';
import "../css/handsontable.full.css";

class SummaryTable extends Component {
    render() {
        let { id, data, headers, cellRenderer } = this.props;
        return (
            <HotTable id={ id }
                ref="hot"
                readOnly={true}
                outsideClickDeselects={false}
                selectionMode="single"
                data={ data }
                columnSorting={true}
                currentRowClassName="currentReportRow"
                colHeaders={ headers }
                rowHeaders={true}
                stretchH="all"
                copyable={false}
                cells={ cellRenderer }
            />
        );
    }
}

export default SummaryTable;